/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  function handleYTVideo() {
    // Select the iframe dynamically (assuming it's the only iframe inside .custom-video)
    const iframe = $('.custom-video iframe')[0];
    // Create and append the custom play button dynamically
    if(iframe) {
      // Ensure the YouTube iframe has the `enablejsapi=1` parameter
      const iframeSrc = $(iframe).attr('src');
      if (!iframeSrc.includes('enablejsapi=1')) {
        $(iframe).attr('src', iframeSrc + (iframeSrc.includes('?') ? '&' : '?') + 'enablejsapi=1');
      }

      const playButton = $('<div>', {
        class: 'custom-play-button',
        text: ''
      }).appendTo('.custom-video');

      // Style the custom play button using jQuery
      playButton.css({
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: '50px',
        color: 'white',
        cursor: 'pointer',
        zIndex: '10'
      });

      // Load the YouTube IFrame API
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // Wait for the YouTube IFrame API to load
      window.onYouTubeIframeAPIReady = function() {
        // Create a YouTube player object
        var player = new YT.Player(iframe, {
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
          }
        });

        // Function to handle when the player is ready
        function onPlayerReady(event) {
          playButton.show();
        }

        // Function to handle player state changes
        function onPlayerStateChange(event) {
          // Show the custom play button when the video is paused
          if (event.data == YT.PlayerState.PAUSED) {
            playButton.show();
          }
          // Hide the custom play button when the video is playing
          if (event.data == YT.PlayerState.PLAYING) {
            playButton.hide();
          }
        }

        // Handle custom play button click
        playButton.click(function() {
          // Play the video using the YouTube player object
          player.playVideo();
        });
      };

    }

  }

  function commitmentMakerFilter() {
    const $filterButtons = $('#commitment-maker-filters button');
    const $results = $('#commitment-maker-results > div');
    const $itemFound = $('.result-found');
    const $noResultFound = $('.no-result-found');
    const $searchInput = $('#commitment-makers-search-input');
    const $activeClass = 'bg-brand-yellow text-white';
    const $disableClass = 'bg-brand-light-gray text-brand-blue';

    // Function to filter results based on the selected category
    const filterResults = (category) => {
      const searchQuery = $searchInput.val().toLowerCase();
      let count = 0;

      $results.hide().each(function () {
        const categories = $(this).data('commitment-maker').split(',');
        const title = $(this).find('.result-card-title').text().toLowerCase();
        const isMatch = (category === 'all' || categories.includes(category)) &&
          (searchQuery === '' || title.includes(searchQuery));

        if (isMatch) {
          $(this).show();
          count++;
        }
      });

      updateResultVisibility(count);
    };

    // Function to handle search input
    const handleSearch = () => {
      const searchQuery = $searchInput.val().toLowerCase();
      const activeButtonCategory = $filterButtons.filter('.bg-brand-yellow').text();
      let count = 0;

      $results.each(function () {
        const categories = $(this).data('commitment-maker').split(',');
        const title = $(this).find('.result-card-title').text().toLowerCase();
        const isMatch = (activeButtonCategory === 'all' || categories.includes(activeButtonCategory)) &&
          (searchQuery === '' || title.includes(searchQuery));
        if (isMatch) {
          $(this).show();
          count++;
        } else {
          $(this).hide();
        }
      });
      updateResultVisibility(count);
    };

    const updateResultVisibility = (count) => {
      if (count === 0) {
        $itemFound.parent().hide();
        $noResultFound.show();
      } else {
        $itemFound.parent().show();
        $noResultFound.hide();
        $itemFound.text(`${count}`)
      }
    };

    // Bind click event to filter buttons
    $filterButtons.on('click', function () {
      // Remove active state from all buttons
      $filterButtons
        .addClass($disableClass)
        .removeClass($activeClass)
        .prop('disabled', false);

      // Set the clicked button as active
      $(this)
        .addClass($activeClass)
        .removeClass($disableClass)
        .prop('disabled', true);

      // Filter results based on the button's text
      const category = $(this).text();
      filterResults(category);
    });

    // Bind input event to search input
    $searchInput.on('input', handleSearch);
    $searchInput.on('reset', function () {
      // Clear the input and trigger the search handler
      $searchInput.val('');
      handleSearch();
    });

    $('.js-reset-search').on('click', () => {
      // Clear the input and trigger the search handler
      $searchInput.val('');
      handleSearch();
    });

    // Set the first button as active and disable it
    $filterButtons.first().click();
  }

  function hasClassName(elem, className) {
    return elem.className.split(' ').indexOf(className) >= 0;
  }

  function addClassName(elem, className) {
    elem.className = [...elem.className.split(' '), className].join(' ');
  }

  function removeClassName(elem, className) {
    elem.className = elem.className
      .split(' ')
      .filter((name) => name !== className)
      .join(' ');
  }

  function capitalize(str) {
    if (typeof str !== 'string') return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function createDropdown(
    baseWidget,
    {
      cssClasses: userCssClasses = {},
      buttonText,
      buttonClassName,
      closeOnChange,
    } = {}
  ) {
    // Merge class names with the default ones and the ones from user
    const cssClasses = {
      root: cx('ais-Dropdown', userCssClasses.root),
      button: cx(CLASS_BUTTON, userCssClasses.button),
      buttonRefined: cx(
        'ais-Dropdown-button--refined',
        userCssClasses.buttonRefined
      ),
      closeButton: cx(CLASS_CLOSE_BUTTON, userCssClasses.closeButton),
    };
    const makeWidget = instantsearch.widgets.panel({
      cssClasses,
      hidden(options) {
        return options.results.nbHits === 0;
      },
      templates: {
        header: (options, {html}) => {
          const {widgetParams} = options;

          let text;
          if (typeof buttonText === 'string') {
            text = buttonText;
          } else if (typeof buttonText === 'function') {
            text = buttonText(options);
          } else {
            // See if the widget has `attribute`
            const attribute =
              widgetParams && widgetParams.attribute
                ? capitalize(widgetParams.attribute)
                : '';
            // Get the number of refinements if the widget has `items`
            const nbRefinements = (options.items || []).filter(
              item => item.isRefined
            ).length;
            // Format the button text
            text =
              nbRefinements > 0 ? `${attribute} (${nbRefinements})` : attribute;
          }

          const classNames = [cssClasses.button];
          if (typeof buttonClassName === 'string') {
            classNames.push(buttonClassName);
          } else if (typeof buttonClassName === 'function') {
            classNames.push(buttonClassName(options));
          } else if ((options.items || []).find(item => item.isRefined)) {
            classNames.push(cssClasses.buttonRefined);
          }

          return html`
            <button type="button" class="${cx(...classNames)}">
              ${`${wpConfig.browseByString} ${wpConfig.additionalStrings[text.replace(/_/g, ' ')] ? wpConfig.additionalStrings[text.replace(/_/g, ' ')] : text.replace(/_/g, ' ') // Replace underscores with spaces
                .replace(/\b\w/g, (char) => char.toUpperCase())}`}
            </button>
            <span class="refinement-clear-icon"></span>
          `;
        },
        footer: (_, {html}) => html`
          <button type="button" class="${cssClasses.closeButton}">Apply</button>`,

      },
    })(baseWidget);

    return widgetParams => {
      const widget = makeWidget(widgetParams);
      let state = {};
      let rootElem, headerElem, closeButtonElem;

      const open = () => {
        addClassName(rootElem, CLASS_OPENED);
        // This 'click' event is still being propagated,
        // so we add this event listener in the next tick.
        // Otherwise, it will immediately close the panel again.
        setTimeout(() => {
          state.windowClickListener = event => {
            // Close if the outside is clicked
            if (!event.composedPath().includes(rootElem)) {
              close();
            }
          };
          // Add an event listener when the panel is opened
          window.addEventListener('click', state.windowClickListener);
        }, 0);
      };
      const close = () => {
        removeClassName(rootElem, CLASS_OPENED);
        // Remove the event listener when the panel is closed
        window.removeEventListener('click', state.windowClickListener);
        delete state.windowClickListener;
      };
      const isOpened = () => hasClassName(rootElem, CLASS_OPENED);
      const toggle = () => {
        if (isOpened()) {
          close();
        } else {
          open();
        }
      };

      // Add a click listener to the header (button)
      const buttonListener = event => {
        if (!event.target.matches('.' + CLASS_BUTTON)) {
          return;
        }
        toggle();
      };

      // Setup a clean-up function, which will be called in `dispose`.
      const cleanUp = () => {
        headerElem.removeEventListener('click', buttonListener);
        if (state.windowClickListener) {
          window.removeEventListener('click', state.windowClickListener);
        }
      };

      // Return a modified version of the widget
      return {
        ...widget,
        $$widgetType: 'cmty.facetDropdown',
        render: options => {
          if (!rootElem) {
            rootElem = document
              .querySelector(widgetParams.container)
              .querySelector('.ais-Panel');
          }

          if (!headerElem) {
            headerElem = rootElem.querySelector('.ais-Panel-header');

            headerElem.addEventListener('click', buttonListener);
          }

          if (!closeButtonElem) {
            closeButtonElem = rootElem.querySelector('.' + CLASS_CLOSE_BUTTON);

            closeButtonElem.addEventListener('click', close);
          }

          // Whenever uiState changes, it closes the panel.
          options.instantSearchInstance.use(() => ({
            subscribe() {
            },
            unsubscribe() {
            },
            onStateChange() {
              if (
                isOpened() &&
                (closeOnChange === true ||
                  (typeof closeOnChange === 'function' &&
                    closeOnChange() === true))
              ) {
                close();
              }
            },
          }));

          return widget.render.call(widget, options);
        },
        dispose: options => {
          if (typeof cleanUp === 'function') {
            cleanUp();
          }

          return widget.dispose.call(widget, options);
        },
      };
    };
  }

  function languageSelection() {
    // Get the container with the language list
    const wpmlContainer = document.querySelector(".wpml-ls-statics-footer");
    if (!wpmlContainer) return;

    // Extract the list items
    const languageItems = wpmlContainer.querySelectorAll("li");

    // Create the new language selector container
    const langSelector = document.createElement("div");
    langSelector.className = "group dropdown lang-selector relative";

    // Create the current language display
    const currentLanguageDiv = document.createElement("div");
    currentLanguageDiv.className =
      "bg-brand-green text-white inline-flex items-center gap-x-1 py-2 px-4 font-bold text-[0.8125rem] tracking-15 uppercase rounded-full cursor-pointer js-lang-toggle";

    // Get the current language (the one with the class "wpml-ls-current-language")
    const currentLanguageItem = wpmlContainer.querySelector(
      ".wpml-ls-current-language"
    );
    if (currentLanguageItem) {
      const currentLanguageName =
        currentLanguageItem.querySelector(".wpml-ls-native").textContent;

      // Add the current language name and down arrow to the display
      currentLanguageDiv.innerHTML = `
      <span class="current-language">${currentLanguageName}</span>
      <img alt="down" src="${wpConfig.THEME_URL}/dist/images/menu-down-arrow.svg" width="11" height="6">
    `;
    }

    // Create the dropdown menu
    const dropdownMenu = document.createElement("div");
    dropdownMenu.id = "langSelectorDropdown";
    dropdownMenu.className =
      "hidden lg:group-hover:block lg:hover:block absolute z-[900099] lg:z-50 -right-5";

    const dropdownContent = document.createElement("div");
    dropdownContent.style.boxShadow = "0 4px 12px rgba(0, 0, 0, .08)";
    dropdownContent.className =
      "dropdown-menu z-[900099] lg:z-50 w-60 border border-[#f0efef] bg-white shadow-menu rounded overflow-hidden mt-2";

    // Loop through all language items and create dropdown links (excluding the current language)
    languageItems.forEach((item) => {
      // Skip the current language item
      if (item.classList.contains("wpml-ls-current-language")) return;

      const languageLink = item.querySelector("a.wpml-ls-link");
      if (languageLink) {
        const languageUrl = languageLink.href;
        const languageName = languageLink.querySelector(".wpml-ls-native")
          .textContent;

        // Create a dropdown link for each language
        const dropdownLink = document.createElement("a");
        dropdownLink.className =
          "block px-4 py-3 hover:font-medium hover:text-brand-orange border-b border-[#00000010]";
        dropdownLink.href = languageUrl;
        dropdownLink.textContent = languageName;

        dropdownContent.appendChild(dropdownLink);
      }
    });

    // Append the dropdown content to the dropdown menu
    dropdownMenu.appendChild(dropdownContent);

    // Append the current language display and dropdown menu to the lang selector
    langSelector.appendChild(currentLanguageDiv);
    langSelector.appendChild(dropdownMenu);

    // Insert the new language selector into the DOM
    const targetContainer = document.querySelector(".lang-selector");
    if (targetContainer) {
      targetContainer.replaceWith(langSelector);
    }

    const $langToggle = $('.js-lang-toggle');
    const $langDropdown = $('#langSelectorDropdown');

    if ($langToggle.length && $langDropdown.length) {
      $langToggle.on('click', function(e) {
        // Only handle click on mobile devices
        if (window.innerWidth < 1024) {
          e.preventDefault();
          $langDropdown.toggleClass('hidden block');
        }
      });

      // Close dropdown when clicking outside
      $(document).on('click', function(e) {
        if (window.innerWidth < 1024 &&
          !$langToggle.is(e.target) &&
          !$.contains($langToggle[0], e.target) &&
          !$langDropdown.is(e.target) &&
          !$.contains($langDropdown[0], e.target)) {
          $langDropdown.addClass('hidden').removeClass('block');
        }
      });
    }
  }

  const cx = (...args) => args.filter(Boolean).join(' ');
  const MOBILE_WIDTH = 375;

  const CLASS_OPENED = 'ais-Dropdown--opened';
  const CLASS_BUTTON = 'ais-Dropdown-button';
  const CLASS_CLOSE_BUTTON = 'ais-Dropdown-close';

  const TYPESENSE_SERVER_CONFIG = {
    apiKey: wpConfig.WP_TYPESENSE_API_KEY, // Be sure to use an API key that only allows searches, in production
    nodes: [
      {
        host: wpConfig.WP_TYPESENSE_SERVER,
        port: wpConfig.WP_TYPESENSE_SERVER_PORT,
        protocol: wpConfig.WP_TYPESENSE_SERVER_PROTOCOL,
      },
    ],
    cacheSearchResultsForSeconds: 0,
  }

  const TYPESENSE_SEARCH_BOX_TEMPLATE = {
    container: '#filter-searchbox',
    placeholder: wpConfig.searchByKeywordString,
    cssClasses: {
      root: 'relative', // Add relative positioning for the search box container
      form: 'w-full', // Ensure the form takes full width
      input: 'w-full py-4 pl-4 pr-16 border border-[#DADADA] rounded-lg text-lg typesense-search-term', // Custom input styles
      submit: 'absolute top-3 right-3 cursor-pointer', // Position the submit button
      reset: 'absolute top-5 right-16 cursor-pointer', // Position the reset button
    },
    templates: {
      submit: `
      <button class="ais-SearchBox-submit flex-shrink-0 border-none bg-transparent" type="submit" title="Submit your search query.">
        <img alt="search" src="${wpConfig.THEME_URL}/dist/images/search-button.svg" width="40" height="40">
      </button>
    `,
      reset: `
      <button class="ais-SearchBox-reset flex-shrink-0 border-none bg-transparent" type="reset" title="Submit your search query.">
        <img alt="search" src="${wpConfig.THEME_URL}/dist/images/input-search-box-reset-icon.svg" width="14" height="14">
      </button>
    `, // Empty reset template
    },
  };

  const TYPESENSE_GLOBAL_SEARCH_BOX_TEMPLATE = {
    container: '#filter-searchbox',
    placeholder: wpConfig.searchByKeywordString,
    cssClasses: {
      root: 'relative', // Add relative positioning for the search box container
      form: 'w-full', // Ensure the form takes full width
      input: 'w-full pr-4 pl-12 py-5 flex items-center rounded-md bg-white global-search-box-bg bg-no-repeat text-brand-dark-gray bg-[center_left_1rem] placeholder:text-brand-dark-gray', // Custom input styles
      submit: 'absolute top-3 right-3 cursor-pointer', // Position the submit button
      reset: 'absolute top-3 right-12 cursor-pointer', // Position the reset button
    },
    templates: {
      submit: `
      <button class="ais-SearchBox-submit flex-shrink-0 border-none bg-transparent" type="submit" title="Submit your search query.">
      </button>
    `,
      reset: '', // Empty reset template
    },
  };

  const TYPESENSE_FILTER_RESULTS_TEMPLATE = {
    container: '#filter-results', // Container for infinite hits
    templates: {
      item(item) {
        return `
           <a href="${item?.permalink}" target="_blank" rel="noopener noreferrer" class="w-full h-full flex flex-col bg-white shadow-box rounded-2xl overflow-hidden">
            <div class="relative w-full mb-2 pt-62-percentage">
              <div class="absolute inset-0 special-topics-card-image">
                <div class="w-full h-full">
                ${item?.post_thumbnail ? item.post_thumbnail : `
                    <img
                      width="1280"
                      height="720"
                      src="${wpConfig.THEME_URL}/dist/images/NoImage-Placeholder-${Math.floor(Math.random() * 4 + 1).toString().padStart(2, '0')}.svg"
                      class="attachment-full size-full wp-post-image"
                      alt="${item?.post_title}"
                    />
                  `}
                </div>
              </div>
              <div class="absolute inset-x-4 top-4">
                ${item?.categories?.length > 0 ? `
                  <div class="absolute right-0 bg-brand-yellow font-bold rounded-lg px-5 py-2 text-white">
                    ${item.categories.map(cat => `<span>${cat}</span>`).join(', ')}
                  </div>
                ` : ''}
              </div>
            </div>
            <div class="flex flex-col justify-between flex-1 pt-2 pb-4 px-8">
              <div>
                <p class="mb-4 text-lg text-brand-royal">${new Date(item?.post_date).toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$1/$2/$3')}</p>
                <h4 class="mt-2 mb-6 text-xl font-medium">
                  <span class="inline-flex items-center text-brand-text text-left font-medium text-xl">${item?.post_title}</span>
                </h4>
                <div class="text-lg text-brand-dark-gray mb-8">
                  ${item?.topics?.length > 0 ? item?.topics?.map(tag => `<span>${tag}</span>`).join(', ') : ''}
                </div>
              </div>
              <span class="inline-flex items-center mb-[0.875rem]">
                <img alt="read more" src="${wpConfig.THEME_URL}/dist/images/more-arrows-orange.svg" width="34" height="25" decoding="async" data-nimg="1" class="relative" loading="lazy" style="color: transparent;">
                <span class="uppercase pl-3 font-medium"> ${wpConfig.readMoreString}</span>
              </span>
            </div>
          </a>

      `;
      },
      showMoreText: wpConfig.loadMoreString, // Text for the "Load More" button
    },
    cssClasses: {
      list: 'ais-InfiniteHits-lis flex flex-wrap justify-center gap-y-10 mb-10',
      item: 'ais-InfiniteHits-item w-full sm:w-1/2 lg:w-1/3 sm:px-5'
    },
    showPrevious: false, // Hide the "Show Previous" button
  }

  const TYPESENSE_GLOBAL_FILTER_RESULTS_TEMPLATE = {
    container: '#filter-results', // Container for infinite hits
    templates: {
      item(item) {
        return `
           <div class="block w-full py-7 border-b-2 border-b-brand-blue-light">
             <a href="${item?.permalink}" target="_blank" rel="noopener noreferrer" class="block w-full">
               <div class="font-medium font-base text-brand-royal">
                 ${item?.is_knowledge_center ? `${wpConfig.knowledgeCenterString} &gt;` : ''} ${wpConfig.globalSearchResultBreadcrumb[item?.type?.[0]] ? wpConfig.globalSearchResultBreadcrumb[item?.type?.[0]] : item?.type}
               </div>
               <div class="mt-2 text-xl text-brand-black font-medium">
                ${item?.post_title}
               </div>
             </a>
             ${item?.post_excerpt ? `
              <div class="block">
                <div class='htmlBlock mt-2 text-base text-brand-black font-normal'>
                  ${item.post_excerpt.replace(/<a href="">Continued<\/a>/g, '')}...
                  <a href="${item?.permalink}" target="_blank" rel="noopener noreferrer">${wpConfig.readMoreString}</a>
                </div>
              </div>
            ` : ''}
          </div>
      `;
      },
      showMoreText: wpConfig.loadMoreString, // Text for the "Load More" button
    },
    cssClasses: {
      list: 'ais-InfiniteHits-list pb-16',
      item: 'ais-InfiniteHits-item'
    },
    showPrevious: false, // Hide the "Show Previous" button
  }

  const TYPESENSE_FILTER_RESULTS_COMMITMENT_DOCUMENTS_TEMPLATE = {
    container: '#filter-results', // Container for infinite hits
    templates: {
      item(item) {
        let year = year ? year : null;
        const post_thumbnail = item?.post_thumbnail || `${wpConfig.THEME_URL}/dist/images/NoImage-Placeholder-04.svg`;
        const post_title = item?.post_title || '';
        const documents = item?.documents || [];
        const options = documents?.map((doc, index) => ({ value: doc?.url, label: doc.language }));

        return `
      <div class='h-full no-translate relative pt-14 pb-8 px-8 bg-white shadow-box rounded-2xl overflow-hidden text-center document-language-container'>
        <div class='absolute inset-x-0 bottom-0 h-4 bg-brand-yellow'></div>
        ${year ? `
          <div class='absolute top-16 right-0 bg-brand-yellow text-white text-lg font-bold py-2 px-6 rounded-l-lg z-30'>
            ${year}
          </div>
        ` : ''}
        <div class='inline-block relative w-full h-96'>
          <img
            class='object-cover object-top'
            src='${post_thumbnail}'
            alt='${post_title}'
            style='width: 100%; height: 100%;'
          />
        </div>
        <p class='mt-6 font-medium text-xl'>${post_title}</p>
        ${documents.length > 0 ? `
          <div class="my-6">
            <div class="relative border border-brand-light-gray-1 rounded-md mx-auto">
              <select
                data-aria-level="Choose Language"
                class="language-select bg-dropdown-arrow bg-no-repeat bg-[position:calc(100%-15px)_center] w-full pt-2 pb-2 px-4 bg-white text-lg rounded-md appearance-none cursor-pointer"
              >
                <option value=''>${wpConfig.chooseLanguageString}</option>
                ${options.sort((a, b) => a.label.localeCompare(b.label)).map(opt => `
                  <option value='${opt?.value}'>${wpConfig.documentAlternativeLangNames[opt.label]}</option>
                `).join('')}
              </select>
            </div>
          </div>
        ` : ''}
        <div class='mt-10 flex items-center justify-end'>
          <a
            class='download-link inline-flex items-center justify-center w-12 h-12 border border-brand-light-gray shadow-default rounded-lg'
            href='${documents[0]?.url || '/'}'
            target='_blank' rel='noreferrer'
          >
            <img
              src='${wpConfig.THEME_URL}/dist/images/download.svg'
              width='29'
              height='29'
              alt='download'
            />
          </a>
        </div>
      </div>
    `;
      },
      showMoreText: wpConfig.loadMoreString,
    },
    cssClasses: {
      list: 'ais-InfiniteHits-lis flex flex-wrap justify-center gap-y-10 mb-10',
      item: 'ais-InfiniteHits-item w-full sm:w-1/2 lg:w-1/3 sm:px-5'
    },
    showPrevious: false, // Hide the "Show Previous" button
  }

  const getStatsTemplate = (postType) => ({
    container: "#stats",
    templates: {
      text: `
      {{#areHitsSorted}}
        {{#hasNoSortedResults}}
          <span class="ais-Stats-text">
            <p class="sm:mx-5 text-lg text-center">${wpConfig.thereIsCurrentlyNoString} ${postType} ${wpConfig.matchingThatSearchString}</p>
          </span>
        {{/hasNoSortedResults}}
        {{#hasOneSortedResults}}
          <p class="mx-4 mb-4 text-lg text-brand-blue pb-2 border-b border-brand-med-gray">
            1 relevant Result sorted out of {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}}
          </p>
        {{/hasOneSortedResults}}
        {{#hasManySortedResults}}
          <p class="mx-4 mb-4 text-lg text-brand-blue pb-2 border-b border-brand-med-gray">
            {{#helpers.formatNumber}}{{nbSortedHits}}{{/helpers.formatNumber}} relevant results sorted out of {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}}
          </p>
        {{/hasManySortedResults}}
      {{/areHitsSorted}}
      {{^areHitsSorted}}
        {{#hasNoResults}}
          <span class="ais-Stats-text">
            <p class="sm:mx-5 text-lg text-center">${wpConfig.thereIsCurrentlyNoString} ${postType} ${wpConfig.matchingThatSearchString}</p>
          </span>
        {{/hasNoResults}}
        {{#hasOneResult}}
          <p class="mx-4 mb-4 text-lg text-brand-blue pb-2 border-b border-brand-med-gray">
            1 ${wpConfig.oneResultFoundString}
          </p>
        {{/hasOneResult}}
        {{#hasManyResults}}
          <p class="mx-4 mb-4 text-lg text-brand-blue pb-2 border-b border-brand-med-gray">
            {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} ${wpConfig.someResultFoundString}
          </p>
        {{/hasManyResults}}
      {{/areHitsSorted}}
    `,
    },
  });

  const getGlobalStatsTemplate = () => ({
    container: "#stats",
    templates: {
      text: `
      {{#areHitsSorted}}
        {{#hasNoSortedResults}}
          <span class="ais-Stats-text">
            <p class="sm:mx-5 text-lg text-center">${wpConfig.noResultFoundString}</p>
          </span>
        {{/hasNoSortedResults}}
        {{#hasOneSortedResults}}
          <p class="py-4 text-lg text-brand-black">
            1 relevant Result sorted out of {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}}
          </p>
        {{/hasOneSortedResults}}
        {{#hasManySortedResults}}
          <p class="py-4 text-lg text-brand-black">
            {{#helpers.formatNumber}}{{nbSortedHits}}{{/helpers.formatNumber}} relevant results sorted out of {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}}
          </p>
        {{/hasManySortedResults}}
      {{/areHitsSorted}}
      {{^areHitsSorted}}
        {{#hasNoResults}}
          <span class="ais-Stats-text">
            <p class="sm:mx-5 text-lg text-center">${wpConfig.noResultFoundString}</p>
          </span>
        {{/hasNoResults}}
        {{#hasOneResult}}
          <p class="py-4 text-lg text-brand-black">
            1 ${wpConfig.oneResultFoundString}
          </p>
        {{/hasOneResult}}
        {{#hasManyResults}}
          <p class="py-4 text-lg text-brand-black">
            {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} ${wpConfig.someResultFoundString}
          </p>
        {{/hasManyResults}}
      {{/areHitsSorted}}
    `,
    },
  });

  const getRefinementButtonTemplate = (containerID, attribute) => ({
    container: containerID,
    attribute: attribute,
    maxValuesPerFacet: 1000,
    sortBy: ["name:asc"],
    limit: 1000, // Number of items to display. Adjust as needed.
    cssClasses: {
      root: 'relative',
      list: 'flex flex-wrap justify-center items-start mb-10 max-w-[68rem] mx-auto',
      item: 'bg-brand-light-gray text-brand-blue rounded-lg cursor-pointer relative mx-2 mb-4', // Item styling
      selectedItem: 'bg-brand-yellow text-white', // Active item styling
    },
    templates: {
      item: (value) => {
        // Extract the display value from the object (assuming `value` has a `label` or `name` property)
        const displayValue = value.label || value.name || value;
        return `
        <button class="w-full px-6 h-[46px] flex justify-center items-center rounded-lg" type="button">
          ${wpConfig.globalSearchResultBreadcrumb[displayValue] ? wpConfig.globalSearchResultBreadcrumb[displayValue] : displayValue}
        </button>
      `;
      },
      selectedItem: (value) => {
        // Extract the display value from the object (assuming `value` has a `label` or `name` property)
        const displayValue = value.label || value.name || value;
        return `
        <button class="w-full px-6 h-[46px] flex justify-center items-center rounded-lg" type="button">
          ${wpConfig.globalSearchResultBreadcrumb[displayValue] ? wpConfig.globalSearchResultBreadcrumb[displayValue] : displayValue}
        </button>
      `;
      },
    },
  });
  const getRefinementListDropdown = createDropdown(
    instantsearch?.widgets?.refinementList,
    {
      closeOnChange: () => window.innerWidth >= MOBILE_WIDTH,
    }
  );

  const getRefinementDropdownTemplate = (containerID, attribute) => (
    getRefinementListDropdown({
      container: containerID,
      attribute: attribute,
      searchable: false,
      limit: 1000,
      sortBy: ["name:asc"],
      maxValuesPerFacet: 1000,
      transformItems(items) {
        return items.map(item => ({
          ...item,
          highlighted: wpConfig.globalSearchResultBreadcrumb[item.label] ? wpConfig.globalSearchResultBreadcrumb[item.label] : item.label,
        }));
      },
    }));

  const initA11yMenu = () => {
    const defaultSettings = {
      colorContrast: false,
      highlightLinks: false,
      textSize: 0,
      letterSpacing: 0,
      pauseAnimations: false,
      cursorSize: 0,
    };

    const menu = document.querySelector(".a11y-menu");
    if (!menu) {
      return;
    }
    const toggle = document.querySelector(".a11y-toggle");
    const close = document.querySelector(".a11y-close");
    const a11ySettingBtns = document.querySelectorAll(".a11y-setting");
    const resetAll = document.querySelector(".a11y-reset-all");
    const a11ySettings = window.localStorage.getItem("a11ySettings");
    const classesToRemove = [
      "a11y-colorContrast",
      "a11y-highlightLinks",
      "a11y-textSize-0",
      "a11y-textSize-1",
      "a11y-textSize-2",
      "a11y-letterSpacing-0",
      "a11y-letterSpacing-1",
      "a11y-letterSpacing-2",
      "a11y-pauseAnimations",
      "a11y-cursorSize-0",
      "a11y-cursorSize-1",
      "a11y-cursorSize-2",
    ];

    if (a11ySettings === null) {
      window.localStorage.setItem(
        "a11ySettings",
        JSON.stringify(defaultSettings)
      );
      document.documentElement.classList.add(
        "a11y-textSize-0",
        "a11y-letterSpacing-0",
        "a11y-cursorSize-0"
      );
    } else {
      const a11ySettingsObj = JSON.parse(a11ySettings);
      const classesToAdd = [];
      Object.keys(a11ySettingsObj).forEach((key) => {
        if (
          ["colorContrast", "highlightLinks", "pauseAnimations"].includes(key)
        ) {
          if (a11ySettingsObj[key]) {
            classesToAdd.push("a11y-" + key);
          }
        } else {
          classesToAdd.push("a11y-" + key + "-" + a11ySettingsObj[key]);
        }
      });

      document.documentElement.classList.remove(...classesToRemove);
      document.documentElement.classList.add(...classesToAdd);
    }

    const openMenu = () => {
      menu.classList.remove("invisible", "opacity-0");
      menu.classList.add("visible", "opacity-100");
      menu.setAttribute("aria-hidden", "false");
      toggle.setAttribute("aria-expanded", "true");
    };

    const closeMenu = () => {
      menu.classList.remove("visible", "opacity-100");
      menu.classList.add("invisible", "opacity-0");
      menu.setAttribute("aria-hidden", "true");
      toggle.setAttribute("aria-expanded", "false");
    };

    const setA11YSetting = (event) => {
      const setting = event.currentTarget.dataset.setting;
      const settings = window.localStorage.getItem("a11ySettings");
      const settingsObj = settings ? JSON.parse(settings) : {};
      if (
        ["colorContrast", "highlightLinks", "pauseAnimations"].includes(setting)
      ) {
        settingsObj[setting] = !settingsObj[setting];
        if (settingsObj[setting]) {
          document.documentElement.classList.add(`a11y-${setting}`);
        } else {
          document.documentElement.classList.remove(`a11y-${setting}`);
        }
      } else {
        document.documentElement.classList.remove(
          `a11y-${setting}-${settingsObj[setting]}`
        );
        settingsObj[setting] =
          settingsObj[setting] === 2 ? 0 : settingsObj[setting] + 1;
        document.documentElement.classList.add(
          `a11y-${setting}-${settingsObj[setting]}`
        );
      }

      window.localStorage.setItem("a11ySettings", JSON.stringify(settingsObj));
    };

    const resetAllSettings = () => {
      window.localStorage.setItem(
        "a11ySettings",
        JSON.stringify(defaultSettings)
      );
      document.documentElement.classList.remove(...classesToRemove);
      document.documentElement.classList.add(
        "a11y-textSize-0",
        "a11y-letterSpacing-0",
        "a11y-cursorSize-0"
      );
    };

    toggle.addEventListener("click", openMenu);
    close.addEventListener("click", closeMenu);
    a11ySettingBtns.forEach((setting) => {
      setting.addEventListener("click", setA11YSetting);
    });

    resetAll.addEventListener("click", resetAllSettings);
  };

  function isBelow1024() {
    return $(window).width() <= 1023;
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        languageSelection();
        initA11yMenu();
        let menuOpen = false;

        // DOM elements
        const $menuIcon = $('#menu-icon');
        const $menuMobile = $('#menu-mobile');

        // Attach event listener
        if ($menuIcon.length) {
          $(document).on('click', '#menu-icon', function(event) {
            menuOpen = !menuOpen;

            // Update menu icon
            $menuIcon.attr('src', menuOpen ? `${wpConfig.THEME_URL}/dist/images/menu-icon-close.svg` : `${wpConfig.THEME_URL}/dist/images/menu-icon.svg`);

            // Toggle menu visibility
            $menuMobile.toggleClass('hidden');
          });
        }


        function setHover(index) {
          const hovers = [false, false, false, false, false, false, false];
          hovers[index] = true;
          document.querySelectorAll('.menu li').forEach((li, i) => {
            li.classList.toggle('hover', hovers[i]);
          });
        }

        function resetHover() {
          document.querySelectorAll('.menu li').forEach(li => li.classList.remove('hover'));
        }

        // Attach hover event listeners
        document.querySelectorAll('.menu li').forEach((li, i) => {
          li.addEventListener('mouseenter', () => setHover(i));
          li.addEventListener('mouseleave', resetHover);
          li.addEventListener('click', resetHover);
        });

        // Toggle "Make a Commitment" menu
        function toggleMakeMenu() {
          const makeMenu = document.getElementById('makeMenu');
          if (makeMenu) {
            makeMenu.style.display = makeMenu.style.display === 'none' ? 'block' : 'none';
          }
        }

        // Attach event listener for "Make a Commitment" button
        const makeCommitmentButton = document.querySelector('.make-commitment-button');
        if (makeCommitmentButton) {
          makeCommitmentButton.addEventListener('click', toggleMakeMenu);
        }

        // Toggle mobile menu items
        function toggleMobileMenuItem(element) {
          element.classList.toggle('active');
          const subItem = element.nextElementSibling;
          if (subItem) {
            subItem.style.display = subItem.style.display === 'none' ? 'block' : 'none';
          }
        }

        // Attach event listeners for mobile menu items
        document.querySelectorAll('.mobile-menu-item > div').forEach(item => {
          item.addEventListener('click', function () {
            toggleMobileMenuItem(this);
          });
        });

      },
      finalize: function () {
        const links = document.querySelectorAll('a[href^="http"], a[href^="//"]');
        if (links) {
          links.forEach(link => {
            if (link.host !== window.location.host) {
              link.setAttribute('target', '_blank');
              link.setAttribute('rel', 'noopener nofollow');
            }
          });
        }

        const backToTopButton = document.getElementById("back-to-top");
        const a11yToggleButton = document.getElementById("a11y-toggle");
        if (backToTopButton) {
          // Show button when scrolling down
          window.addEventListener("scroll", () => {
            backToTopButton.classList.toggle("hidden", window.scrollY <= 300);
          });

          // Smooth scroll to top on click
          backToTopButton.addEventListener("click", () => {
            window.scrollTo({top: 0, behavior: "smooth"});
          });
        }

        if (a11yToggleButton) {
          // Show button when scrolling down
          window.addEventListener("scroll", () => {
            a11yToggleButton.classList.toggle("hidden", window.scrollY <= 300);
          });
        }

        const closeButton = document.querySelector('.close-button');
        if (closeButton) {
          closeButton.addEventListener('click', function () {
            window.history.back() || window.close();
          });
        }

        $('select.select2').each(function () {
          const placeholderText = $(this).data('placeholder') || "Select options";

          $(this).select2({
            placeholder: placeholderText,
            minimumResultsForSearch: -1,
            allowClear: true,
            closeOnSelect: true, // Keep dropdown open after selection
            templateResult: function (data) {
              if (!data.id) {
                return data.text;
              }
              return $(`<span class="select-checkbox"></span><span class="pl-3">${data.text}</span>`);
            },
          }).on('select2:close', function () {
            const $select = $(this);
            // Early return if id is empty
            if (!$select.val()) {
              return;
            }
            const numSelected = $select.select2('data').length;
            const totalOptions = $select.find('option').length;
            let displayText;
            let value = $select.val();
            if (numSelected === totalOptions) {
              displayText = 'All items are selected.';
            } else {
              displayText = Array.isArray(value) ? value.join(', ') : value;
            }

            if (numSelected) {
              // Update the selection display
              $select.next('.select2').find('.select2-selection__rendered').html(
                `<span class="truncate">${displayText}</span>`
              );
            } else {
              // Update the selection display
              $select.next('.select2').find('.select2-selection__rendered').html(``);
            }
          });
        });


        document.querySelectorAll(".accordion > .accordion-item > .accordion-header").forEach((header) => {
          header?.addEventListener("click", () => {
            const currentAccordionItem = header?.closest(".accordion-item");
            const isActive = header?.classList?.contains("active");

            if (isActive) {
              collapseItem(currentAccordionItem);
            } else {
              expandItem(currentAccordionItem);

              // Collapse only sibling accordion items at the same level
              currentAccordionItem.parentElement
                .querySelectorAll(":scope > .accordion-item")
                .forEach((item) => {
                  if (item !== currentAccordionItem) {
                    collapseItem(item);
                  }
                });
              // Add a delay and offset for scrolling
              setTimeout(function () {
                const offset = -220; // Adjust this value as needed
                const elementPosition = currentAccordionItem.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset + offset;

                window.scrollTo({
                  top: offsetPosition,
                  behavior: "smooth",
                });
              }, 200); // Adjust the delay as needed
            }
          });
        });

        // Function to expand an accordion item
        function expandItem(item) {
          const collapse = item?.querySelector(":scope > .accordion-collapse");
          if (collapse) {
            collapse.style.maxHeight = collapse.scrollHeight + "px";
            collapse.style.opacity = "1";
            item.querySelector(":scope > .accordion-header").classList.add("active");

            // Reset the max-height to auto after the animation ends
            collapse.addEventListener("transitionend", function onTransitionEnd() {
              collapse.style.maxHeight = "none";
              collapse.removeEventListener("transitionend", onTransitionEnd);
            });
          }
        }

        // Function to collapse an accordion item
        function collapseItem(item) {
          const collapse = item?.querySelector(":scope > .accordion-collapse");
          if (collapse) {
            collapse.style.maxHeight = collapse.scrollHeight + "px"; // Set to current height to trigger transition
            collapse.offsetHeight; // Trigger reflow to apply transition
            collapse.style.maxHeight = "0";
            collapse.style.opacity = "0";
            item.querySelector(":scope > .accordion-header").classList.remove("active");
          }
        }

        const $tabToggle = $('.tab-toggle');
        const $tabNavigation = $('.tab-navigation');
        const $tabItems = $('.tab-item');
        const $tabPanels = $('.tab-panel');
        const $activeTabName = $('.active-tab-name');
        const $activeClass = 'block lg:inline-block px-3 lg:px-6 lg:rounded-full py-2 bg-white text-brand-royal';
        const $disabledClass = 'block cursor-pointer lg:inline-block px-3 lg:px-6 py-2';

        $tabToggle.on('click', () => {
          $tabNavigation.toggle();
        });

        $tabItems.on('click', function () {
          const index = $(this).data('index');

          $tabItems.removeClass($activeClass).addClass($disabledClass);
          $(this).removeClass($disabledClass).addClass($activeClass);

          $tabPanels.addClass('hidden');
          $(`.tab-panel[data-index="${index}"]`).removeClass('hidden');
        });

        $(document).on('click', '.toggle-sub-menu', function(event) {
          if (isBelow1024()) {
            event.preventDefault(); // Prevent default behavior if needed
            $(this).next('.toggle-sub-menu-content').find('>div').toggleClass('hidden');
          }
        });

        handleYTVideo();

        $(document).on('click', '.refinement-clear-icon', function(event) {
          $('#clear-refinements').find('button').click();
        });

        $(document).on('click', '#announcement .close-announcement', function(event) {
          document.cookie = `announcement_bar_${$(this).data('announcement-id')}=1; path=/; max-age=2592000`;
          $('#announcement').remove();
          if (jQuery(window).width() < 767) {
            jQuery('[role="document"]').css('padding-top', '106px');
          }
        });

        const wpSearchInput = document.querySelector('.wp-search-box input');
        const wpResetButton = document.querySelector('.js-reset-search');

        if (wpSearchInput && wpResetButton) {
          // Show/hide reset button based on input content
          wpSearchInput.addEventListener('input', function() {
            if (this.value.length > 0) {
              wpResetButton.classList.remove('hidden');
            } else {
              wpResetButton.classList.add('hidden');
            }
          });

          // Clear input when reset button is clicked
          wpResetButton.addEventListener('click', function() {
            wpSearchInput.value = '';
            wpResetButton.classList.add('hidden');
            wpSearchInput.focus();
          });
        }
      }
    },
    'single_toolkit': {
      init: function () {

      },
      finalize: function () {
        $('.tabbed-panels-1').each((index, container) => {
          const $tabbedPanelsContainer = $(container);
          const $panelsContainer = $tabbedPanelsContainer.find('.panels-container');
          const $tabs = $tabbedPanelsContainer.find('[role="tab"]');

          // Function to set min-height based on content
          const setPanelHeight = () => {
            if ($(window).width() >= 768) {
              const $firstPanel = $tabbedPanelsContainer.find('[role="tabpanel"]').first();
              const contentHeight = $firstPanel.outerHeight();
              const tabsHeight = $panelsContainer.find('[role="tablist"]').outerHeight();
              const maxHeight = Math.max(contentHeight || 0, tabsHeight || 0) + 100;

              $tabbedPanelsContainer.css('min-height', maxHeight + 'px');
            } else {
              $tabbedPanelsContainer.css('min-height', '');
            }
          };

          // Initialize height
          setPanelHeight();

          // Update on window resize
          $(window).on('resize', setPanelHeight);

          $tabs.on('click', function() {
            const $clickedTab = $(this);
            const index = $clickedTab.data('index');

            // Update tabs in current container only
            $tabbedPanelsContainer.find('[role="tab"]')
              .removeClass('text-brand-yellow')
              .addClass('text-white')
              .attr('aria-selected', 'false');

            $clickedTab
              .removeClass('text-white')
              .addClass('text-brand-yellow')
              .attr('aria-selected', 'true');

            // Update panels in current container only
            $tabbedPanelsContainer.find('[role="tabpanel"]')
              .removeClass('visible opacity-100')
              .addClass('hidden invisible opacity-0');

            $tabbedPanelsContainer.find(`h4[data-index="${index}"]`)
              .removeClass('hidden invisible opacity-0')
              .addClass('visible opacity-100');

            $tabbedPanelsContainer.find(`.panel-data[data-index="${index}"]`)
              .removeClass('hidden invisible opacity-0')
              .addClass('visible opacity-100');

            setPanelHeight();

            $('html, body').animate({
              scrollTop: $panelsContainer.offset().top - 100
            }, 500);
          });

          // Keyboard navigation
          $tabs.on('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              $(this).trigger('click');
            }
          });
        });
      }
     },
    'contact': {
      init: function () {

      },
      finalize: function () {
        const inquirySelect = $('#inquiry'); // Use jQuery for Select2
        const otherOptionDiv = document.querySelector('.other-option');
        const otherInquiryInput = document.getElementById('other-inquiry');
        if (inquirySelect) {
          inquirySelect?.on('change', function () {
            if (this.value.toLowerCase() === 'other') {
              otherOptionDiv.classList.remove('hidden');
              otherInquiryInput.setAttribute('required', 'required');
            } else {
              otherOptionDiv.classList.add('hidden');
              otherInquiryInput.removeAttribute('required');
            }
          });
        }

        $("#contact-form").submit(async function (event) {
          event.preventDefault();
          $('#submitting-form').removeClass('hidden');
          const allowedKeys = [
            'first_name', 'last_name', 'email_address', 'preferred_language',
            'org_name', 'org_type', 'interest', 'inquiry', 'message', 'other_inquiry', '_wpcf7_unit_tag'
          ];
          const formData = new FormData(this);
          for (let [key, value] of formData.entries()) {
            console.log(`key: ${key} value: ${value}`)
          }
          let filteredData = {};

          for (let [key, value] of formData.entries()) {
            if (allowedKeys.includes(key)) {
              if (filteredData[key]) {
                // If key already exists, append value with a comma separator
                filteredData[key] += `, ${value}`;
              } else {
                filteredData[key] = value;
              }
            }
          }

          // If 'other_inquiry' exists, append it to 'inquiry'
          if (filteredData.other_inquiry) {
            filteredData.inquiry = filteredData.inquiry
              ? `${filteredData.inquiry}: ${filteredData.other_inquiry}`
              : filteredData.other_inquiry;
          }

          delete filteredData?.other_inquiry;
          const payload = new FormData();
          for (const key in filteredData) {
            payload.append(key, filteredData[key]);
          }
          $.ajax({
            url: wpConfig.CONTACT_FORM_POST_ENDPOINT,
            type: 'POST',
            data: payload,
            processData: false, // Prevent jQuery from processing the data
            contentType: false, // Prevent jQuery from setting contentType
            success: function (response) {
              if (response?.status === 'mail_sent') {
                $('#contact-form-content').remove();
                $('#contact-form-thank-you').fadeIn();
              }
              $('#submitting-form').addClass('hidden');
            },
            error: function () {
              $('#error-message').text('There was an error on our end. Please try again.').removeClass('hidden');
              $('#submitting-form').addClass('hidden');
            }
          });
        });
      }
    },
    // Subscribe page
    'subscribe': {
      init: function () {

      },
      finalize: function () {

        $("#subscribe-form").submit(async function (event) {
          event.preventDefault();
          $('#submitting-form').removeClass('hidden');
          const allowedKeys = [
            'first_name', 'last_name', 'email_address', 'country', 'preferred_language', 'interest',
            'org_name', 'org_type', '_wpcf7_unit_tag'
          ];
          const formData = new FormData(this);
          for (let [key, value] of formData.entries()) {
            console.log(`key: ${key} value: ${value}`)
          }
          let filteredData = {};

          for (let [key, value] of formData.entries()) {
            if (allowedKeys.includes(key)) {
              if (filteredData[key]) {
                // If key already exists, append value with a comma separator
                filteredData[key] += `, ${value}`;
              } else {
                filteredData[key] = value;
              }
            }
          }

          const payload = new FormData();
          for (const key in filteredData) {
            payload.append(key, filteredData[key]);
          }
          $.ajax({
            url: wpConfig.SUBSCRIBE_FORM_POST_ENDPOINT,
            type: 'POST',
            data: payload,
            processData: false, // Prevent jQuery from processing the data
            contentType: false, // Prevent jQuery from setting contentType
            success: function (response) {
              if (response?.status === 'mail_sent') {
                $('#subscribe-form-content').remove();
                $('#subscribe-form-thank-you').fadeIn();
              }
              $('#submitting-form').addClass('hidden');
            },
            error: function () {
              $('#error-message').text('There was an error on our end. Please try again.').removeClass('hidden');
              $('#submitting-form').addClass('hidden');
            }
          });
        });
      }
    },

    // Home page
    'home': {
      init: function () {

      },
      finalize: function () {
        const swiper = new Swiper('.home-slider-wrap .swiper', {
          slidesPerView: 1.1,
          spaceBetween: 15,
          breakpoints: {
            // when window width is >= 320px
            600: {
              slidesPerView: 2.3,
              spaceBetween: 30
            },
            // when window width is >= 480px
            1200: {
              slidesPerView: 3.3,
              spaceBetween: 30
            }
          },
          // Navigation arrows
          navigation: {
            nextEl: '#slider-next',
            prevEl: '#slider-prev',
          },
        });
      }
    },

    'data_hub': {
      init: function () {

      },
      finalize: function () {
        const swiper = new Swiper('.tracker-slider .swiper', {
          slidesPerView: 1,
          spaceBetween: 16,
          breakpoints: {
            // when window width is >= 320px
            640: {
              slidesPerView: 1.8
            },
            992: {
              slidesPerView: 2.3
            },
            1200: {
              slidesPerView: 2.8
            }
          },
          // Navigation arrows
          navigation: {
            nextEl: '#slider-next',
            prevEl: '#slider-prev',
          },
        });

        const typesenseSelector = $('#typesense-integration');
        const dataType = typesenseSelector.data('type');
        const queryBy = typesenseSelector.data('query-by');
        const highlightFullFields = typesenseSelector.data('highlight-full-fields');
        const queryByWeights = typesenseSelector.data('query-by-weights');

        if (dataType) {
          const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
            server: TYPESENSE_SERVER_CONFIG,
            additionalSearchParameters: {
              query_by: queryBy,
              highlight_full_fields: highlightFullFields,
              query_by_weights: queryByWeights,
              sort_by: "_text_match:desc,sort_by_date:desc",
              page: 1,
              num_typos: 2,
            }
          });
          const searchClient = typesenseInstantsearchAdapter.searchClient;
          const {
            searchBox,
            stats,
            configure,
            infiniteHits
          } = instantsearch.widgets;

          const relatedResourcesSearch = instantsearch({
            searchClient,
            indexName: dataType
          });

          relatedResourcesSearch.addWidgets([
            searchBox(TYPESENSE_SEARCH_BOX_TEMPLATE),
            stats(getStatsTemplate(dataType)),
            infiniteHits(TYPESENSE_FILTER_RESULTS_TEMPLATE),
            configure({
              hitsPerPage: 9,
              facets: ['language_code', 'categories'],
              facetsRefinements: {
                language_code: [wpConfig.LANGUAGE_CODE],
                categories: ['Track20'],
              },
            }),
          ]);

          relatedResourcesSearch.start()
        }
      }
    },

    //About page
    'about': {
      init: function () {

      },
      finalize: function () {
        const swiper = new Swiper('.history-slider-wrap .swiper', {
          slidesPerView: 1.15,
          spaceBetween: 15,
          breakpoints: {
            600: {
              slidesPerView: 2.3,
              spaceBetween: 30
            },
            1200: {
              slidesPerView: 3.3,
              spaceBetween: 30
            },
            1536: {
              slidesPerView: 4.3,
              spaceBetween: 30
            }
          },
          // Navigation arrows
          navigation: {
            nextEl: '#slider-next',
            prevEl: '#slider-prev',
          },
        });

        const yearSelect = document.getElementById('year-select');
        if (yearSelect) {
          yearSelect?.addEventListener('change', function () {
            const selectedYear = this.value;
            const slides = document?.querySelectorAll('.swiper-slide');
            let targetIndex = 0;

            for (let i = 0; i < slides.length; i++) {
              if (slides[i].getAttribute('data-year') === selectedYear) {
                targetIndex = i; // Set the target index to the first match
                break; // Exit the loop as soon as the first match is found
              }
            }

            // Slide to the first index of the selected year
            swiper.slideTo(targetIndex);
          });
        }

        const regionalHubsSelect = $('#regional-hubs-select');
        if (regionalHubsSelect) {
          regionalHubsSelect?.on('change', function () {
            const selectedValue = this.value; // Get the selected value
            const teamMembers = document.querySelectorAll('#team-member-results > div'); // Get all team member divs
            teamMembers?.forEach(div => {
              const region = div.getAttribute('data-regional-hubs'); // Get the region attribute

              // Show or hide the div based on the selected value
              if (selectedValue === "" || region === selectedValue || region === "All") {
                div.classList.remove('hidden'); // Show the div
              } else {
                div.classList.add('hidden'); // Hide the div
              }
            });
          })
          const teamMemberResults = $('#team-member-results');
          if (teamMemberResults.length > 0) {
            teamMemberResults.find('a').on('click', (event) => {
              event.preventDefault(); // Prevent the default link behavior

              // Get the visible div IDs
              const visibleIds = [];
              teamMemberResults.find('> div:not(.hidden):not(.no-bio)').each((index, element) => {
                visibleIds.push($(element).attr('id'));
              });

              // Create the new href with the visible IDs as a query parameter
              const idsString = visibleIds.join(',');
              let base64IdsString = '';
              if (idsString) {
                base64IdsString = btoa(idsString);
              }
              const originalHref = $(event.currentTarget).attr('href'); // Use event.currentTarget to get the clicked <a>
              const newHref = `${originalHref}?trck=${base64IdsString}`;

              // Open the new href in a new tab
              window.open(newHref, '_blank');
            });
          }
        }

        const meetTheMembersAccordion = $('#meet-the-members');
        if (meetTheMembersAccordion) {
          const buttonLeadership = $('button#Leadership, button#Direction, button#Liderazgo');
          if (buttonLeadership) {
            buttonLeadership.addClass('active');
            buttonLeadership.next().css({
              'max-height': 'none',
              'opacity': '1'
            });
          }
        }
      }
    },

    'careers_internships': {
      init: function () {

      },
      finalize: function () {
        // Cache selectors to avoid duplicate lookups
        const $jobSearchInput = $('#job-search-input');
        const $regionalHubsSelect = $('#regional-hubs-select');
        const $jobResults = $('#job-results > li');
        const $resultCount = $('#result-count');
        const $noResultFound = $('#no-result-found');
        const $searchSuggestions = $('#search-suggestions');
        const $suggestionsList = $searchSuggestions.find('ul');

// Extract all job data for suggestions
        const jobData = $jobResults.map(function() {
          const $job = $(this);
          return {
            title: $job.find('.text-h3').text().trim(),
            type: $job.find('p:contains("Type:")').text().replace('Type:', '').trim(),
            text: $job.text().toLowerCase()
          };
        }).get();

// Function to filter job listings
        const filterJobs = () => {
          // Get the search keyword and selected region
          const searchKeyword = $jobSearchInput.val().toLowerCase();
          const selectedRegion = $regionalHubsSelect.val();

          // Hide all job listings initially
          $jobResults.hide();

          // Filter job listings based on the search keyword and selected region
          let visibleCount = 0;
          $jobResults.each((index, element) => {
            const $job = $(element);
            const jobText = $job.text().toLowerCase();
            const jobRegion = $job.attr('data-regional-hubs');

            // Check if the job listing matches the search keyword and selected region
            if ((!searchKeyword || jobText.includes(searchKeyword)) &&
              (!selectedRegion || jobRegion === selectedRegion)) {
              $job.show();
              visibleCount++;
            }
          });

          // Update the result count or show the no-result message
          if (visibleCount > 0) {
            $resultCount.text(`${visibleCount} Results`).show();
            $noResultFound.hide();
          } else {
            $resultCount.hide();
            $noResultFound.show();
          }
        };

// Function to show suggestions
        const showSuggestions = (keyword) => {
          if (!keyword) {
            $searchSuggestions.hide();
            return;
          }

          const keywordLower = keyword.toLowerCase();
          const matchedTitles = new Set(); // Using Set to avoid duplicates

          jobData.forEach(job => {
            // Check if keyword matches in title, type, or full text
            if (job.title.toLowerCase().includes(keywordLower) ||
              job.type.toLowerCase().includes(keywordLower) ||
              job.text.includes(keywordLower)) {
              matchedTitles.add(job.title);
            }
          });

          if (matchedTitles.size > 0) {
            $suggestionsList.empty();
            matchedTitles.forEach(title => {
              $suggestionsList.append(`<li class="px-4 py-2 hover:bg-gray-100 cursor-pointer">${title}</li>`);
            });
            $searchSuggestions.show();
          } else {
            $searchSuggestions.hide();
          }
        };

// Handle suggestion click
        $suggestionsList.on('click', 'li', function() {
          $jobSearchInput.val($(this).text());
          $searchSuggestions.hide();
          filterJobs();
        });

// Trigger live search on input in the search field
        $jobSearchInput.on('input', function() {
          filterJobs();
          showSuggestions($(this).val());
        });

// Trigger live search when the region dropdown changes
        $regionalHubsSelect.on('change', filterJobs);

// Hide suggestions when clicking outside
        $(document).on('click', function(e) {
          if (!$(e.target).closest('.wp-search-box').length) {
            $searchSuggestions.hide();
          }
        });

// Optional: Reset functionality to clear the search and show all listings
        function resetJobSearch() {
          $jobResults.show();
          $resultCount.text(`${$jobResults.length} Results`).show();
          $noResultFound.hide();
          $searchSuggestions.hide();
          $jobSearchInput.val('');
        }

// Handle form reset
        $('#job-search').on('reset', resetJobSearch);

// Handle reset button click
        $('.js-reset-search').on('click', resetJobSearch);
      }
    },

    'single_regional_hubs': {
      init: function () {

      },
      finalize: function () {
        const inquirySelect = $('#inquiry'); // Use jQuery for Select2
        const otherOptionDiv = document.querySelector('.other-option');
        const otherInquiryInput = document.getElementById('other-inquiry');
        if (inquirySelect) {
          inquirySelect?.on('change', function () {
            if (this.value.toLowerCase() === 'other') {
              otherOptionDiv.classList.remove('hidden');
              otherInquiryInput.setAttribute('required', 'required');
            } else {
              otherOptionDiv.classList.add('hidden');
              otherInquiryInput.removeAttribute('required');
            }
          });
        }

        $("#regional-hub-contact-form").submit(async function (event) {
          event.preventDefault();
          $('#submitting-form').removeClass('hidden');
          const allowedKeys = [
            'first_name', 'last_name', 'email_address',
            'inquiry', 'message', 'hub_name', 'additional_emails', '_wpcf7_unit_tag'
          ];
          const formData = new FormData(this);
          for (let [key, value] of formData.entries()) {
            console.log(`key: ${key} value: ${value}`)
          }
          let filteredData = {};

          for (let [key, value] of formData.entries()) {
            if (allowedKeys.includes(key)) {
              if (filteredData[key]) {
                // If key already exists, append value with a comma separator
                filteredData[key] += `, ${value}`;
              } else {
                filteredData[key] = value;
              }
            }
          }

          // If 'other_inquiry' exists, append it to 'inquiry'
          if (filteredData.other_inquiry) {
            filteredData.inquiry = filteredData.inquiry
              ? `${filteredData.inquiry}: ${filteredData.other_inquiry}`
              : filteredData.other_inquiry;
          }

          delete filteredData?.other_inquiry;
          const payload = new FormData();
          for (const key in filteredData) {
            payload.append(key, filteredData[key]);
          }
          $.ajax({
            url: wpConfig.CONTACT_FORM_HUB_POST_ENDPOINT,
            type: 'POST',
            data: payload,
            processData: false, // Prevent jQuery from processing the data
            contentType: false, // Prevent jQuery from setting contentType
            success: function (response) {
              if (response?.status === 'mail_sent') {
                $('#regional-hub-contact-form-thank-you').fadeIn();
              }
              $('#submitting-form').addClass('hidden');
            },
            error: function () {
              $('#error-message').text('There was an error on our end. Please try again.').removeClass('hidden');
              $('#submitting-form').addClass('hidden');
            }
          });
        });
      }
    },
    'commitment_makers': {
      init: function () {

      },
      finalize: function () {
        commitmentMakerFilter();
      }
    },
    'single_commitment_maker': {
      init: function () {

      },
      finalize: function () {
        const swiper = new Swiper('.predicted-impact-slider .swiper', {
          slidesPerView: 1,
          spaceBetween: 15,
          breakpoints: {
            // when window width is >= 320px
            600: {
              slidesPerView: 1.7,
              spaceBetween: 16
            },
            // when window width is >= 480px
            1200: {
              slidesPerView: 2.3,
              spaceBetween: 16
            }
          },
          // Navigation arrows
          navigation: {
            nextEl: '#slider-next',
            prevEl: '#slider-prev',
          },
        });
      }
    },
    'impact': {
      init: function () {

      },
      finalize: function () {
        const swiper = new Swiper('.impact-slider-wrap .swiper', {
          slidesPerView: 1,
          spaceBetween: 16,
          breakpoints: {
            // when window width is >= 320px
            600: {
              slidesPerView: 2.3
            },
            // when window width is >= 480px
            1200: {
              slidesPerView: 2.8
            }
          },
          // Navigation arrows
          navigation: {
            nextEl: '#slider-next',
            prevEl: '#slider-prev',
          },
        });

        const typesenseSelector = $('#typesense-integration');
        const dataType = typesenseSelector.data('type');
        const queryBy = typesenseSelector.data('query-by');
        const highlightFullFields = typesenseSelector.data('highlight-full-fields');
        const queryByWeights = typesenseSelector.data('query-by-weights');

        if (dataType) {
          const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
            server: TYPESENSE_SERVER_CONFIG,
            additionalSearchParameters: {
              query_by: queryBy,
              highlight_full_fields: highlightFullFields,
              query_by_weights: queryByWeights,
              sort_by: "_text_match:desc,sort_by_date:desc",
              page: 1,
              num_typos: 2,
            }
          });
          const searchClient = typesenseInstantsearchAdapter.searchClient;
          const {
            searchBox,
            stats,
            configure,
            infiniteHits,
            clearRefinements
          } = instantsearch.widgets;

          const relatedImpactSearch = instantsearch({
            searchClient,
            indexName: dataType
          });

          relatedImpactSearch.addWidgets([
            searchBox(TYPESENSE_SEARCH_BOX_TEMPLATE),
            stats(getStatsTemplate(dataType)),
            getRefinementDropdownTemplate('#types-refinement-list', 'type'),
            clearRefinements({
              container: '#clear-refinements',
              includedAttributes: ['type'],
            }),
            infiniteHits(TYPESENSE_FILTER_RESULTS_TEMPLATE),
            configure({
              hitsPerPage: 9,
              facets: ['language_code', 'is_knowledge_center','is_impact' ],
              facetsRefinements: {
                language_code: [wpConfig.LANGUAGE_CODE],
                is_impact: [1],
                is_knowledge_center: [1],
              },
            }),
          ]);

          relatedImpactSearch.start()
        }
      }
    },
    'focus_areas': {
      init: function () {

      },
      finalize: function () {
        // Constants
        const focus_areas_search_input = '#focus-areas-search-input';
        const focus_areas_select_box = '#focus-areas-select-box';
        const filter_buttons = '.w-full.sm\\:w-1\\/3.px-2 button';
        const result_container = '#focus-areas-search-result';
        const result_items = '#focus-areas-search-result ul li';
        const results_found = '#results-found';
        const no_results_message = '#no-results-found';
        const count_span = '#count';

        // Function to filter results
        const filterResults = () => {
          const searchTerm = $(focus_areas_search_input).val().toLowerCase();
          const selectedFocusAreas = $(focus_areas_select_box).val() || [];
          const selectedButtons = $(filter_buttons).filter('.active').map((_, btn) => $(btn).text().trim().toLowerCase()).get();

          let visibleItems = 0;

          $(result_items).each((_, item) => {
            const title = $(item).data('title').toLowerCase();
            const type = $(item).data('type').toLowerCase();

            const matchesSearch = title.includes(searchTerm);
            const matchesFocusArea = selectedFocusAreas.length === 0 || selectedFocusAreas.some(area => title.includes(area.toLowerCase()));
            const matchesButtons = selectedButtons.length === 0 || selectedButtons.includes(type);

            if (matchesSearch && matchesFocusArea && matchesButtons) {
              $(item).show();
              visibleItems++;
            } else {
              $(item).hide();
            }
          });

          // Update the count and show/hide the no results message
          $(count_span).text(visibleItems);
          if (visibleItems === 0) {
            $(results_found).hide();
            $(no_results_message).show();
          } else {
            $(no_results_message).hide();
            $(results_found).show();
          }
        };

        // Search input
        $(focus_areas_search_input).on('input', filterResults);

        // Select box
        $(focus_areas_select_box).on('change', filterResults);

        // Filter buttons
        $(filter_buttons).on('click', function () {
          $(this).toggleClass('active bg-brand-yellow text-white');
          filterResults();
        });

        // Initial filter to show all items
        filterResults();
      }
    },
    'single_special_topics': {
      init: function () {
      },
      finalize: function () {
        const typesenseSelector = $('#typesense-integration');
        const dataType = typesenseSelector.data('type');
        const focusArea = typesenseSelector.data('focus-area');
        if (dataType && focusArea) {
          const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
            server: TYPESENSE_SERVER_CONFIG,
            additionalSearchParameters: {
              query_by: 'podcast' === dataType ? "post_title, topics,special_topics" : "post_title,categories,topics,special_topics",
              sort_by: "_text_match:desc,sort_by_date:desc",
              highlight_full_fields: 'podcast' === dataType ? "post_title, topics,special_topics" : "post_title,categories,topics,special_topics",
              page: 1,
              num_typos: 2,
              query_by_weights: 'podcast' === dataType ? "3,1,1" : "3,1,1,1",
            }
          });
          const searchClient = typesenseInstantsearchAdapter.searchClient;
          const {
            searchBox,
            stats,
            configure,
            refinementList,
            infiniteHits
          } = instantsearch.widgets;

          const focusAreaSearch = instantsearch({
            searchClient,
            indexName: dataType
          });

          focusAreaSearch.addWidgets([
            searchBox(TYPESENSE_SEARCH_BOX_TEMPLATE),
            stats(getStatsTemplate(dataType)),
            infiniteHits(TYPESENSE_FILTER_RESULTS_TEMPLATE),
            configure({
              hitsPerPage: 9,
              facets: ['special_topics', 'language_code'], // Add contributor_types to facets
              facetsRefinements: {
                special_topics: [focusArea],
                language_code: [wpConfig.LANGUAGE_CODE],
              },
            }),
          ]);

          if ('podcast' !== dataType) {
            focusAreaSearch.addWidget(refinementList(getRefinementButtonTemplate('#categories-refinement-list', 'categories')))
          }

          focusAreaSearch.start()
        }
      }
    },
    'for_donors': {
      init: function () {
      },
      finalize: function () {
        const typesenseSelector = $('#typesense-integration');
        const dataType = typesenseSelector.data('type');
        const makeACommitmentOptions = typesenseSelector.data('make-a-commitment-options');
        if (dataType && makeACommitmentOptions) {
          const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
            server: TYPESENSE_SERVER_CONFIG,
            additionalSearchParameters: {
              query_by: "post_title,categories,topics",
              sort_by: "_text_match:desc,sort_by_date:desc",
              highlight_full_fields: "post_title,categories,topics",
              page: 1,
              num_typos: 2,
              query_by_weights: "3,1,1",
            }
          });
          const searchClient = typesenseInstantsearchAdapter.searchClient;
          const {
            searchBox,
            stats,
            configure,
            refinementList,
            infiniteHits,
            clearRefinements
          } = instantsearch.widgets;

          const makeACommitmentSearch = instantsearch({
            searchClient,
            indexName: dataType
          });

          makeACommitmentSearch.addWidgets([
            searchBox(TYPESENSE_SEARCH_BOX_TEMPLATE),
            refinementList(getRefinementButtonTemplate('#categories-refinement-list', 'categories')),
            getRefinementDropdownTemplate('#topics-refinement-list', 'topics'),
            clearRefinements({
              container: '#clear-refinements',
              includedAttributes: ['topics'],
            }),
            stats(getStatsTemplate(dataType)),
            infiniteHits(TYPESENSE_FILTER_RESULTS_TEMPLATE),
            configure({
              hitsPerPage: 9,
              facets: ['make_a_commitment', 'language_code', 'make_a_commitment_options'], // Add contributor_types to facets
              facetsRefinements: {
                make_a_commitment: [1],
                language_code: [wpConfig.LANGUAGE_CODE],
                make_a_commitment_options: [makeACommitmentOptions],
              },
            }),
          ]);

          makeACommitmentSearch.start()
        }

        commitmentMakerFilter();
      }
    },
    'for_ngs': {
      init: function () {
      },
      finalize: function () {
        const typesenseSelector = $('#typesense-integration');
        const dataType = typesenseSelector.data('type');
        const makeACommitmentOptions = typesenseSelector.data('make-a-commitment-options');
        if (dataType && makeACommitmentOptions) {
          const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
            server: TYPESENSE_SERVER_CONFIG,
            additionalSearchParameters: {
              query_by: "post_title,categories,topics",
              sort_by: "_text_match:desc,sort_by_date:desc",
              highlight_full_fields: "post_title,categories,topics",
              page: 1,
              num_typos: 2,
              query_by_weights: "3,1,1",
            }
          });
          const searchClient = typesenseInstantsearchAdapter.searchClient;
          const {
            searchBox,
            stats,
            configure,
            refinementList,
            infiniteHits,
            clearRefinements
          } = instantsearch.widgets;

          const makeACommitmentSearch = instantsearch({
            searchClient,
            indexName: dataType
          });

          makeACommitmentSearch.addWidgets([
            searchBox(TYPESENSE_SEARCH_BOX_TEMPLATE),
            refinementList(getRefinementButtonTemplate('#categories-refinement-list', 'categories')),
            getRefinementDropdownTemplate('#topics-refinement-list', 'topics'),
            clearRefinements({
              container: '#clear-refinements',
              includedAttributes: ['topics'],
            }),
            stats(getStatsTemplate(dataType)),
            infiniteHits(TYPESENSE_FILTER_RESULTS_TEMPLATE),
            configure({
              hitsPerPage: 9,
              facets: ['make_a_commitment', 'language_code', 'make_a_commitment_options'], // Add contributor_types to facets
              facetsRefinements: {
                make_a_commitment: [1],
                language_code: [wpConfig.LANGUAGE_CODE],
                make_a_commitment_options: [makeACommitmentOptions],
              },
            }),
          ]);

          makeACommitmentSearch.start()
        }
        commitmentMakerFilter();

        const focusAreasSlider = $('#focus-areas-slider');
        if (focusAreasSlider.length > 0) {
          const sliderInner = document.getElementById('focus-areas-inner');
          const slider = document.getElementById('focus-areas-slider');

          let startY;
          let startLeft;

          slider.addEventListener('wheel', (e) => {
            e.preventDefault();
            const strength = Math.abs(e.deltaY);
            if (e.deltaY === 0) return;

            const currentLeft = parseFloat(window.getComputedStyle(sliderInner).left) || 0;
            updateLeft(currentLeft - e.deltaY);
          });

          slider.addEventListener('touchstart', (e) => {
            startY = e.touches[0].clientY;
            startLeft = parseFloat(window.getComputedStyle(sliderInner).left) || 0;
          });

          slider.addEventListener('touchmove', (e) => {
            e.preventDefault();
            const diffY = startY - e.touches[0].clientY;
            updateLeft(startLeft - diffY);
          });

          function updateLeft(newLeftValue) {
            const windowWidth = window.innerWidth;
            let maxLeft;

            if (windowWidth > 1700) {
              maxLeft = -20400;
            } else if (windowWidth > 1500) {
              maxLeft = -20500;
            } else {
              maxLeft = -21000;
            }

            const newLeft = Math.min(Math.max(newLeftValue, maxLeft), 0);
            sliderInner.style.left = `${newLeft}px`;
          }
        }
      }
    },
    'for_governments': {
      init: function () {
      },
      finalize: function () {
        const typesenseSelector = $('#typesense-integration');
        const dataType = typesenseSelector.data('type');
        const makeACommitmentOptions = typesenseSelector.data('make-a-commitment-options');
        if (dataType && makeACommitmentOptions) {
          const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
            server: TYPESENSE_SERVER_CONFIG,
            additionalSearchParameters: {
              query_by: "post_title,categories,topics",
              sort_by: "_text_match:desc,sort_by_date:desc",
              highlight_full_fields: "post_title,categories,topics",
              page: 1,
              num_typos: 2,
              query_by_weights: "3,1,1",
            }
          });
          const searchClient = typesenseInstantsearchAdapter.searchClient;
          const {
            searchBox,
            stats,
            configure,
            refinementList,
            infiniteHits,
            clearRefinements
          } = instantsearch.widgets;

          const makeACommitmentSearch = instantsearch({
            searchClient,
            indexName: dataType
          });

          makeACommitmentSearch.addWidgets([
            searchBox(TYPESENSE_SEARCH_BOX_TEMPLATE),
            refinementList(getRefinementButtonTemplate('#categories-refinement-list', 'categories')),
            getRefinementDropdownTemplate('#topics-refinement-list', 'topics'),
            clearRefinements({
              container: '#clear-refinements',
              includedAttributes: ['topics'],
            }),
            stats(getStatsTemplate(dataType)),
            infiniteHits(TYPESENSE_FILTER_RESULTS_TEMPLATE),
            configure({
              hitsPerPage: 9,
              facets: ['make_a_commitment', 'language_code', 'make_a_commitment_options'], // Add contributor_types to facets
              facetsRefinements: {
                make_a_commitment: [1],
                language_code: [wpConfig.LANGUAGE_CODE],
                make_a_commitment_options: [makeACommitmentOptions],
              },
            }),
          ]);

          makeACommitmentSearch.start()
        }

        commitmentMakerFilter();
      }
    },
    'make_commitment': {
      init: function () {
      },
      finalize: function () {
        const typesenseSelector = $('#typesense-integration');
        const dataType = typesenseSelector.data('type');
        if (dataType) {
          const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
            server: TYPESENSE_SERVER_CONFIG,
            additionalSearchParameters: {
              query_by: "post_title,categories,topics,make_a_commitment",
              sort_by: "_text_match:desc,sort_by_date:desc",
              highlight_full_fields: "post_title,categories,topics,make_a_commitment",
              page: 1,
              num_typos: 2,
              query_by_weights: "3,1,1,1",
            }
          });
          const searchClient = typesenseInstantsearchAdapter.searchClient;
          const {
            searchBox,
            stats,
            configure,
            refinementList,
            infiniteHits,
            clearRefinements
          } = instantsearch.widgets;

          const makeACommitmentSearch = instantsearch({
            searchClient,
            indexName: dataType
          });

          makeACommitmentSearch.addWidgets([
            searchBox(TYPESENSE_SEARCH_BOX_TEMPLATE),
            refinementList(getRefinementButtonTemplate('#make-a-commitment-options-refinement-list', 'make_a_commitment_options')),
            refinementList(getRefinementButtonTemplate('#categories-refinement-list', 'categories')),
            getRefinementDropdownTemplate('#topics-refinement-list', 'topics'),
            clearRefinements({
              container: '#clear-refinements',
              includedAttributes: ['topics'],
            }),
            stats(getStatsTemplate(dataType)),
            infiniteHits(TYPESENSE_FILTER_RESULTS_TEMPLATE),
            configure({
              hitsPerPage: 9,
              facets: ['make_a_commitment', 'language_code'], // Add contributor_types to facets
              facetsRefinements: {
                make_a_commitment: [1],
                language_code: [wpConfig.LANGUAGE_CODE],
              },
            }),
          ]);

          makeACommitmentSearch.start()
        }

        commitmentMakerFilter();
      }
    },
    'knowledge_center': {
      init: function () {
      },
      finalize: function () {
        const typesenseSelector = $('#typesense-integration');
        const dataType = typesenseSelector.data('type');
        const sortBy = typesenseSelector.data('sort-by') || '_text_match:desc,sort_by_date:desc';
        const queryBy = typesenseSelector.data('query-by');
        const highlightFullFields = typesenseSelector.data('highlight-full-fields');
        const queryByWeights = typesenseSelector.data('query-by-weights');

        const topicsRefinementSelector = $('#topics-refinement-list');
        const categoriesRefinementSelector = $('#categories-refinement-list');

        if (dataType) {
          const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
            server: TYPESENSE_SERVER_CONFIG,
            additionalSearchParameters: {
              query_by: queryBy,
              highlight_full_fields: highlightFullFields,
              query_by_weights: queryByWeights,
              sort_by: sortBy,
              page: 1,
              num_typos: 2,
            }
          });
          const searchClient = typesenseInstantsearchAdapter.searchClient;
          const {
            searchBox,
            stats,
            configure,
            refinementList,
            infiniteHits,
            clearRefinements
          } = instantsearch.widgets;

          const knowledgeCenterSearch = instantsearch({
            searchClient,
            indexName: dataType
          });

          knowledgeCenterSearch.addWidgets([
            searchBox(TYPESENSE_SEARCH_BOX_TEMPLATE),
            stats(getStatsTemplate(dataType)),
            infiniteHits('commitment_document' === dataType ? TYPESENSE_FILTER_RESULTS_COMMITMENT_DOCUMENTS_TEMPLATE : TYPESENSE_FILTER_RESULTS_TEMPLATE),
            configure({
              hitsPerPage: 9,
              facets: dataType === 'global_search_item' ? ['language_code', 'is_knowledge_center'] : ['language_code'],
              facetsRefinements: {
                ...(dataType === 'global_search_item' && { is_knowledge_center: [1] }),
                ...(dataType === 'commitment_document' && { 'documents.language': [wpConfig.documentLangNames[wpConfig.LANGUAGE_CODE]] }),
                language_code: [wpConfig.LANGUAGE_CODE],
              },
            })
          ]);
          if (topicsRefinementSelector.length > 0) {
            knowledgeCenterSearch.addWidget(
              getRefinementDropdownTemplate('#topics-refinement-list', topicsRefinementSelector.data('attribute')),
            );
            knowledgeCenterSearch.addWidget(
              clearRefinements({
                container: '#clear-refinements',
                includedAttributes: [topicsRefinementSelector.data('attribute')],
              }),
            )
          }
          if (categoriesRefinementSelector.length > 0) {
            knowledgeCenterSearch.addWidget(
              refinementList(getRefinementButtonTemplate('#categories-refinement-list', categoriesRefinementSelector.data('attribute'))),
            );
          }

          knowledgeCenterSearch.start()
        }

        $(document).on("change", ".language-select", function () {
          const selectedURL = $(this).val();
          const container = $(this).closest(".document-language-container");
          const downloadLink = container.find(".download-link");

          if (selectedURL) {
            downloadLink.attr("href", selectedURL);
          }
        });
      }
    },
    'privacy_policy': {
      init: function () {
      },
      finalize: function () {
        const policyItems = document.querySelectorAll('.policy-item');
        const policyContentBlocks = document.querySelectorAll('#policy-content > div');

        // Hide all content blocks except the first one
        policyContentBlocks.forEach((block, index) => {
          if (index !== 0) {
            block.style.display = 'none';
          }
        });

        // Add click event listeners to policy items
        policyItems?.forEach((item) => {
          item?.addEventListener('click', () => {
            const index = item.getAttribute('data-index');

            // Update active state for policy items
            policyItems.forEach((el, i) => {
              const arrow = el.querySelector('.w-12');
              const text = el.querySelector('.text-p');
              if (i == index) {
                arrow.classList.remove('opacity-0');
                text.classList.add('font-medium', 'text-brand-royal');
                text.classList.remove('text-brand-dark-gray');
              } else {
                arrow.classList.add('opacity-0');
                text.classList.remove('font-medium', 'text-brand-royal');
                text.classList.add('text-brand-dark-gray');
              }
            });

            // Show the corresponding content block and hide others
            policyContentBlocks.forEach((block, i) => {
              if (i == index) {
                block.style.display = 'block';
              } else {
                block.style.display = 'none';
              }
            });
          });
        });
      },
    },
    'search': {
      init: function () {
      },
      finalize: function () {
        const typesenseSelector = $('#typesense-integration');
        const dataType = typesenseSelector.data('type');
        if (dataType) {
          const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
            server: TYPESENSE_SERVER_CONFIG,
            additionalSearchParameters: {
              query_by: "post_title,categories,topics",
              sort_by: "_text_match:desc,sort_by_date:desc",
              highlight_full_fields: "post_title,categories,topics",
              page: 1,
              num_typos: 2,
              query_by_weights: "3,1,1",
            }
          });
          const searchClient = typesenseInstantsearchAdapter.searchClient;
          const {
            searchBox,
            stats,
            configure,
            infiniteHits
          } = instantsearch.widgets;

          const globalSearch = instantsearch({
            searchClient,
            indexName: dataType
          });

          globalSearch.addWidgets([
            searchBox(TYPESENSE_GLOBAL_SEARCH_BOX_TEMPLATE),
            stats(getGlobalStatsTemplate()),
            infiniteHits(TYPESENSE_GLOBAL_FILTER_RESULTS_TEMPLATE),
            configure({
              hitsPerPage: 9,
              facets: ['language_code'], // Add contributor_types to facets
              facetsRefinements: {
                language_code: [wpConfig.LANGUAGE_CODE],
              },
            }),
          ]);

          globalSearch.start()
        }

        // Function to handle search input from filter-searchbox
        const handleFilterSearch = () => {
          const $filterSearchBox = $('#filter-searchbox');
          const $searchInput = $filterSearchBox.find('input');
          const $currentRefinement = $('#current-refinement');
          const $resultContainer = $('#result-container');

          $searchInput.on('input', function() {
            const searchQuery = $(this).val();
            $('.search-input-value').text(searchQuery);

            if (!searchQuery) {
              $currentRefinement.hide();
              $resultContainer.hide();
            } else {
              $currentRefinement.show();
              $resultContainer.show();
            }
          });
        };
        handleFilterSearch();
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
